// @flow

export default {
  resolution: {
    lg: 1024,
  },
  auth: {
    strSplitter: {
      url: '://',
      subDomain: 'secure',
      getRequest: {},
      postRequest: {},
    },
  },
  payment: {
    staticData: 'LAYOUT_DATA',
    bankCards: ['parcelamento', 'payPal'],
    booking: {
      post: {
        url: '/booking',
        params: {
          method: 'POST',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      },
    },
    errorMessage: {
      code: 404,
      logoSrc: '//www.adagio-city.com/themes/custom/adagio/static/media/LOGO_ADAGIO_2023.svg',
      expirationPopIn: {
        bgImage: '//www.adagio-city.com/themes/custom/adagio/static/media/bg-error-page2.jpg',
        title: 'UPS...',
        text: 'Something went wrong, please, go to Home page',
      },
    },
  },
  gtm: {
    logo: {
      event: 'GAevent',
      eventCategory: 'Navigation',
      eventAction: 'Header - Click on CTA',
      eventLabel: 'Logo',
    },
    clientAgreePopIn: {
      event: 'GAevent',
      eventCategory: 'Booking funnel - Payment',
      eventAction: 'Checkout - Click on CTA',
      eventLabel: 'New client pop-in - Agree',
    },
    basketConditionsAgreement: {
      event: 'GAevent',
      eventCategory: 'Booking funnel - Payment',
      eventAction: 'Payment - Click on CTA',
      eventLabel: 'confirm the reservation',
    },
    breadcrumbsFirstStep: {
      event: 'GAevent',
      eventCategory: 'booking funnel step 3 - payment',
      eventAction: 'breadcrumb - click on cta',
      eventLabel: 'back to apartments and options',
    },
    breadcrumbsSecondStep: {
      event: 'GAevent',
      eventCategory: 'booking funnel step 3 - payment',
      eventAction: 'breadcrumb - click on cta',
      eventLabel: 'back to information',
    },
  },
};
